<template>
  <div class="customer-case">
    <div v-if="isPcFlag" class="customer-case-pc">
      <div class="total-title">客户成功案例</div>
      <div class="content">
        <OrgList class="customer-case" :orgTypeList="orgList.orgTypeList" :imgs="orgList.imgs"></OrgList>
      </div>
    </div>
    <div v-else class="customer-case-h5"></div>
  </div>
</template>

<script>
import dataList from '../dataList'
export default {
  props: {
    isPcFlag: Boolean, // 是Pc还是H5
    dataList: Array,
  },
  components: {
    OrgList: () => import('../../extension/components/pc/OrgList.vue'),
  },
  data() {
    return {
      orgList: dataList.CustomerCaseList,
    }
  },
}
</script>

<style lang="less" scoped>
.basisDisplay(@justify,@align) {
  display: flex;
  justify-content: @justify;
  align-items: @align;
}
.columnDisplay(@justify,@align) {
  display: flex;
  flex-direction: column;
  justify-content: @justify;
  align-items: @align;
}
.customer-case {
  width: 100%;
  background: #fff;
  padding-bottom: 40px;
  .customer-case-pc {
    width: 100%;
    .columnDisplay(center, center);
    .total-title {
      width: 100%;
      height: 72px;
      font-size: 34px;
      background: #de2221;
      color: #fff;
      .basisDisplay(center, center);
    }
    .content {
      width: 100%;
      max-width: 1320px;
      .basisDisplay(center, center);
      /deep/ .con {
        padding-top: 0;
        .con-wrap {
          width: 1320px;
          .bar {
            color: #0f0f0f;
          }
        }
        .swiper-container {
          width: 1320px;
        }
        .swiper-slide {
          width: 1320px !important;
        }
      }
    }
  }
}
</style>
